import React, { useState, useEffect } from 'react'
import { Col, Message, Panel, Placeholder, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import HTMLWidget from '../../HTMLWidget'
import ViewSettingFormListWidget from '../dynamicForm/ViewSettingFormListWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { saveFormResultsReport } from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { Link } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import CustomAlertMessage from '../../CustomAlertMessage'

export default function ResultsReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const { Paragraph } = Placeholder

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormResultsReport(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema?.outcomes?.forEach((item) => {
      let collectData =
        data[
          `${formSchema?.inputForm?.dataToCollect?.name}:${item.id || ''}:${item.refId || ''}`
        ] || null
      let howtoCollectData =
        data[
          `${formSchema?.inputForm?.dataCollection?.name}:${item.id || ''}:${item.refId || ''}`
        ] || null

      values.push({
        id: item.id,
        refId: item.refId,
        collectData: collectData,
        howtoCollectData: howtoCollectData,
      })
    })

    let request = {
      id: formSchema.id,
      values: values,
    }

    console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {formSchema.dependency && (
        <Message
          showIcon
          type="error"
          description={
            <>
              {formSchema.dependencyMsg}{' '}
              <Link
                to={{
                  pathname: `${pathname.subProjectNew.proposal.projectObjectiveOutcomeIndicator}`,
                }}
              >
                <u>คลิกเพื่อไปกรอกข้อมูล</u>
              </Link>
            </>
          }
          style={{ marginBottom: 20 }}
        />
      )}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}
      {formSchema.detail && (
        // <Row style={{ marginBottom: 20 }}>&nbsp; &nbsp; &nbsp; &nbsp; {formSchema.detail}</Row>
        <HTMLWidget style={{ marginLeft: 0, marginTop: -10 }} data={formSchema.detail} />
      )}

      {isEdit && showCommandButton ? (
        <>
          {formSchema.description && (
            <Row style={{ marginBottom: 10, marginTop: 10 }}>
              <CustomAlertMessage contents={formSchema.description} />
            </Row>
          )}

          {formSchema?.outcomes?.map((e) => {
            return (
              <Panel
                header={`ผลลัพธ์ : ${e.outcome}`}
                collapsible
                defaultExpanded
                bordered
                style={{ marginBottom: 10 }}
              >
                <div style={{ marginTop: -10, marginBottom: 20 }}>
                  <ViewSettingFormListWidget
                    objects={e.indicator}
                    header={'ตัวชี้วัด'}
                    collapsible
                    defaultExpanded
                    // bordered
                  />

                  {formSchema?.inputForm?.dataToCollect && (
                    <Row style={{ marginLeft: 20 }}>
                      <CKEditorFrom
                        schema={formSchema?.inputForm?.dataToCollect}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        value={e.dataToCollect}
                        name={`${formSchema.inputForm.dataToCollect.name}:${e.id || ''}:${
                          e.refId || ''
                        }`}
                      />
                    </Row>
                  )}

                  {formSchema?.inputForm?.dataCollection && (
                    <Row style={{ marginTop: 10, marginLeft: 20 }}>
                      <CKEditorFrom
                        schema={formSchema.inputForm.dataCollection}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        value={e.dataCollection}
                        name={`${formSchema.inputForm.dataCollection.name}:${e.id || ''}:${
                          e.refId || ''
                        }`}
                      />
                    </Row>
                  )}
                </div>
              </Panel>
            )
          })}
        </>
      ) : (
        <>
          {formSchema?.outcomes?.map((e) => {
            return (
              <Panel header={`ผลลัพธ์ : ${e.outcome}`} collapsible defaultExpanded>
                <div style={{ marginTop: -10, marginBottom: 20 }}>
                  <ViewSettingFormListWidget
                    objects={e.indicator}
                    header={'ตัวชี้วัด'}
                    collapsible
                    defaultExpanded
                    //prefix={'- '}
                    // bordered
                  />

                  {formSchema?.inputForm?.dataToCollect && (
                    <Row style={{ marginLeft: 20 }}>
                      <Col>
                        <strong>{formSchema.inputForm.dataToCollect.label}</strong>
                      </Col>
                      <Col style={{ marginTop: 10, marginLeft: 20 }}>
                        {e.dataToCollect ? (
                          <div dangerouslySetInnerHTML={{ __html: e.dataToCollect }} />
                        ) : (
                          <Paragraph />
                        )}
                      </Col>
                    </Row>
                  )}

                  {formSchema?.inputForm?.dataCollection && (
                    <Row style={{ marginTop: 10, marginLeft: 20 }}>
                      <Col>
                        <strong>{formSchema.inputForm.dataCollection.label}</strong>
                      </Col>
                      <Col style={{ marginTop: 10, marginLeft: 20 }}>
                        {e.dataCollection ? (
                          <div dangerouslySetInnerHTML={{ __html: e.dataCollection }} />
                        ) : (
                          <Paragraph />
                        )}
                      </Col>
                    </Row>
                  )}
                </div>
              </Panel>
            )
          })}
        </>
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
